"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePhoneAccessOnSuccess = exports.socialValidatePhoneOwnershipOnSuccess = exports.socialValidatePhoneAccessOnSuccess = exports.socialValidateEmailOwnershipOnSuccess = exports.socialValidateAndAccountCreateOnSuccess = exports.socialEmailConfirmationOnSuccess = exports.onValidationSuccess = exports.onSubmitAccountFormSuccess = exports.onSocialSubmitAccountFormSuccess = exports.onBeginSocialLoginSuccess = exports.login = exports.handleSocialLoginRequestFailure = exports.handleRequestFailure = exports.completeSocialLogin = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("./constants");
var _redirect = require("./redirect");
var _routing = require("./routing");
var _actions = require("./actions");
var login = function () {
  var _ref = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(data, redirectUrl, dispatch, flow) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch((0, _actions.loginSucceeded)(data, flow));
          case 2:
            (0, _redirect.goToRedirectPage)({
              redirectUrl: redirectUrl,
              dispatch: dispatch
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function login(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
exports.login = login;
var completeSocialLogin = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(data, redirectUrl, dispatch, provider, flow) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return dispatch((0, _actions.socialLoginSucceded)(data, provider, flow));
          case 2:
            (0, _redirect.goToRedirectPage)({
              redirectUrl: redirectUrl,
              dispatch: dispatch
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function completeSocialLogin(_x5, _x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();
exports.completeSocialLogin = completeSocialLogin;
var validatePhoneAccessOnSuccess = function validatePhoneAccessOnSuccess(redirectUrl, dispatch) {
  return function (data) {
    if (data.emailMask !== undefined) {
      dispatch((0, _actions.pinPhoneValidated)({
        user_verified: false,
        new_user: false
      }));
      (0, _routing.goToVerifyEmailPage)(dispatch)();
    } else {
      dispatch((0, _actions.pinPhoneValidated)({
        user_verified: true,
        new_user: false
      }));
      login(data, redirectUrl, dispatch, _constants.LOGIN_FLOW.PHONE_SIGN_IN);
    }
  };
};
exports.validatePhoneAccessOnSuccess = validatePhoneAccessOnSuccess;
var socialValidatePhoneOwnershipOnSuccess = function socialValidatePhoneOwnershipOnSuccess(redirectUrl, dispatch, provider) {
  return function (data) {
    dispatch((0, _actions.pinPhoneValidated)({
      user_verified: true,
      new_user: false
    }));
    completeSocialLogin(data, redirectUrl, dispatch, provider, _constants.LOGIN_FLOW.SOCIAL_EMAIL_MATCH_ASSOCIATION);
  };
};
exports.socialValidatePhoneOwnershipOnSuccess = socialValidatePhoneOwnershipOnSuccess;
var socialValidatePhoneAccessOnSuccess = function socialValidatePhoneAccessOnSuccess(dispatch) {
  return function () {
    dispatch((0, _actions.pinPhoneValidated)({
      user_verified: true,
      new_user: true
    }));
    (0, _routing.goToSocialCreateAccountPage)(dispatch)();
  };
};
exports.socialValidatePhoneAccessOnSuccess = socialValidatePhoneAccessOnSuccess;
var socialValidateAndAccountCreateOnSuccess = function socialValidateAndAccountCreateOnSuccess(dispatch, email, provider, redirectUrl) {
  return function (data) {
    dispatch((0, _actions.pinPhoneValidated)({
      user_verified: true,
      new_user: true
    }));
    dispatch((0, _actions.loginUserCreated)(email));
    dispatch((0, _actions.socialLoginSucceded)(data, provider, _constants.LOGIN_FLOW.SOCIAL_SIGN_UP_WITHOUT_CPF));
    (0, _redirect.goToRedirectPage)({
      redirectUrl: redirectUrl,
      dispatch: dispatch
    });
  };
};
exports.socialValidateAndAccountCreateOnSuccess = socialValidateAndAccountCreateOnSuccess;
var socialEmailConfirmationOnSuccess = function socialEmailConfirmationOnSuccess(dispatch) {
  return function () {
    (0, _routing.goToEmailConfirmationPage)(dispatch)();
  };
};
exports.socialEmailConfirmationOnSuccess = socialEmailConfirmationOnSuccess;
var socialValidateEmailOwnershipOnSuccess = function socialValidateEmailOwnershipOnSuccess(dispatch, provider) {
  return function (data) {
    dispatch((0, _actions.socialLoginSucceded)(data, provider, _constants.LOGIN_FLOW.SOCIAL_PHONE_MATCH_ASSOCIATION));
    (0, _routing.goToCredencialAssociatedPage)(dispatch)();
  };
};
exports.socialValidateEmailOwnershipOnSuccess = socialValidateEmailOwnershipOnSuccess;
var onSubmitAccountFormSuccess = function onSubmitAccountFormSuccess(redirectUrl, onSuccess, dispatch) {
  return function (data) {
    if (onSuccess) {
      onSuccess(data);
    }
    if (data.confirmationNeeded) {
      (0, _routing.goToActivateAccountPage)(dispatch)();
    } else {
      dispatch((0, _actions.loginUserCreated)(data.email));
      login(data, redirectUrl, dispatch, _constants.LOGIN_FLOW.PHONE_SIGN_UP);
    }
  };
};
exports.onSubmitAccountFormSuccess = onSubmitAccountFormSuccess;
var onSocialSubmitAccountFormSuccess = function onSocialSubmitAccountFormSuccess(redirectUrl, dispatch, provider) {
  return function (data) {
    dispatch((0, _actions.loginUserCreated)(data.email));
    completeSocialLogin(data, redirectUrl, dispatch, provider, _constants.LOGIN_FLOW.SOCIAL_SIGN_UP);
  };
};
exports.onSocialSubmitAccountFormSuccess = onSocialSubmitAccountFormSuccess;
var onBeginSocialLoginSuccess = function onBeginSocialLoginSuccess(redirectUrl, dispatch, provider) {
  return function (data) {
    completeSocialLogin(data, redirectUrl, dispatch, provider, _constants.LOGIN_FLOW.SOCIAL_DIRECT_SIGN_IN);
  };
};
exports.onBeginSocialLoginSuccess = onBeginSocialLoginSuccess;
var onValidationSuccess = function onValidationSuccess(redirectUrl, dispatch, flow) {
  return function (data) {
    login(data, redirectUrl, dispatch, flow);
  };
};
exports.onValidationSuccess = onValidationSuccess;
var handleRequestFailure = function handleRequestFailure(clearUser, dispatch) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (data) {
    var error = data.details ? data.details.error : undefined;
    switch (error) {
      case _constants.errors.invalidSession:
        clearUser();
        (0, _routing.goToLoginPage)(dispatch)();
        break;
      case _constants.errors.invalidPhone:
        dispatch((0, _actions.requestFailureInvalidPhoneNumber)());
        break;
      case _constants.errors.userNotFound:
        dispatch((0, _actions.pinPhoneValidated)({
          user_verified: false,
          new_user: true
        }));
        (0, _routing.goToCreateAccountPage)(dispatch)();
        break;
      case _constants.errors.invalidToken:
        dispatch(_actions.tokenValidationActions[props.type]);
        break;
      case _constants.errors.youAreARobot:
        dispatch((0, _actions.requestFailureYouAreARobot)());
        break;
      case _constants.errors.userIsBlocked:
        dispatch((0, _actions.requestFailureUserIsBlocked)());
        break;
      case _constants.errors.supportNeeded:
        dispatch((0, _actions.requestFailureSupportNeeded)());
        break;
      default:
        dispatch((0, _actions.requestFailureUnknownError)());
        break;
    }
  };
};
exports.handleRequestFailure = handleRequestFailure;
var handleSocialLoginRequestFailure = function handleSocialLoginRequestFailure(clearUser, dispatch) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (data) {
    var error = data.details ? data.details.error : undefined;
    var payload = data.details ? data.details : undefined;
    switch (error) {
      case _constants.errors.invalidSession:
      case _constants.errors.unauthorized:
      case _constants.errors.cognitoNotAuthorized:
        clearUser();
        (0, _routing.goToLoginPage)(dispatch)();
        break;
      case _constants.errors.invalidPhone:
        dispatch((0, _actions.requestFailureInvalidPhoneNumber)());
        break;
      case _constants.errors.socialCredentialUnknown:
        (0, _routing.goToPhoneConfirmationPage)(dispatch)();
        break;
      case _constants.errors.socialCredentialMatched:
        (0, _routing.goToOwnershipVerificationPage)(dispatch)(payload);
        break;
      case _constants.errors.phoneNumberMatched:
        dispatch((0, _actions.pinPhoneValidated)({
          user_verified: false,
          new_user: false
        }));
        dispatch((0, _actions.socialLoginPhoneMatched)(payload));
        (0, _routing.goToAccountMatchPage)(dispatch)();
        break;
      case _constants.errors.invalidToken:
        dispatch(_actions.tokenValidationActions[props.type]);
        break;
      case _constants.errors.youAreARobot:
        dispatch((0, _actions.requestFailureYouAreARobot)());
        break;
      case _constants.errors.userIsBlocked:
        dispatch((0, _actions.requestFailureUserIsBlocked)());
        break;
      case _constants.errors.supportNeeded:
        dispatch((0, _actions.requestFailureSupportNeeded)());
        break;
      default:
        dispatch((0, _actions.requestFailureUnknownError)());
        dispatch((0, _actions.setResponse)({
          status: _constants.ERROR,
          type: error || _constants.errors.unknownError
        }));
        break;
    }
  };
};
exports.handleSocialLoginRequestFailure = handleSocialLoginRequestFailure;